import React from "react";

import Dropdown from "../dropdown/Dropdown";
import DropdownLink from "../dropdown/DropdownLink";

import { MoreHorizontal } from "react-feather";
import { useChangeToDone, useDeleteTodo } from "./queries/useQuery";

const TodoListItem = props => {
  const { todo } = props;

  const { mutate: change, isLoading: loadingChange } = useChangeToDone(todo);
  const { mutate: deleteTodo, isLoading: loadingDelete } = useDeleteTodo(todo);

  const handleUpdateTodo = () => change({ title: todo.title, completed: !todo.completed, deleted: false });

  const handleDeleteTodo = () => deleteTodo({ title: todo.title, completed: todo.completed, deleted: true });

  return (
    <li key={todo.id} className="todo__item">
      <label className="todo__label">
        <input className="todo__checkbox" type="checkbox" defaultChecked={todo.completed} onChange={handleUpdateTodo} />
        <span className="todo__text" title={todo.title}>{todo.title}</span>
      </label>

      <Dropdown icon={<MoreHorizontal size={16} />} bttnSize={24} classes="rounded-bttn rounded-bttn--open">
        <DropdownLink onClick={handleDeleteTodo}>
          {loadingDelete ? "Excluindo..." : "Excluir tarefa"}
        </DropdownLink>
      </Dropdown>
    </li>
  );
}

export default TodoListItem;